module.exports = __webpack_public_path__ + "img/icon-search.313c3c01.svg";